import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { Localization } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("LOCALIZATION_MODULE");

export const moduleActions = createDataModuleActions<Localization>(actionCreator);
export const getLocalizationTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const localizationActions = {
  ...normalizeActions(moduleActions.data),
};
export const localizationActionCreators = {
  ...moduleActions,
};
